"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaginationContext = void 0;

var react_1 = require("react");

exports.PaginationContext = (0, react_1.createContext)({
  /* eslint-disable-next-line @typescript-eslint/no-empty-function */
  onChange: function onChange() {},
  currentPage: 1,
  totalPages: 1,
  nextLabel: '',
  prevLabel: '',
  pageLabel: '',
  currentLabel: '',
  isInverse: false
});